import React from 'react';
import botTestdrive from '@images/botTest.png';
import { playData } from '@util/config';

const HowToPlayGuidence = () => {
    return (
        <section className="bot-frodo-first-sections">
            <div className="bot-test-drive">
                <div>
                    <img src={botTestdrive} alt="img-fluid" />
                </div>
                <p className="bot-frodo-title">Complete a Test Drive to Unlock Open-World Game!</p>
            </div>
            <div className="how-to-play-section">
                <div className="how-to-play-left-block">
                    <div className="how-tow-play-inner-block">
                        <p className="how-tow-play-left-title">How to play:</p>
                        <div className="for-tow-inner">
                            {playData.map((item, index) => (
                                <div className="how-tow-play-left-detalis" key={index}>
                                    <img src={item.icons} alt="img-fluid" className='w-[32px] h-[32px]' />
                                    <div>
                                        <p className="how-tow-play-card-title">{item.label}</p>
                                        <p className="how-tow-play-card-details">
                                            {item.details}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="how-to-play-right-block">
                    <div className="test-drive-video">
                        <iframe
                            id="myVideo"
                            className="video-test-drive"
                            width="100%"
                            src="https://www.youtube.com/embed/mswO0rzbPnM?rel=0?version=3&autoplay=1&mute=1&controls=0&showinfo=0&loop=1&playlist=mswO0rzbPnM"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowToPlayGuidence;